module.exports = __webpack_public_path__ + "static/media/ESCORTS_F1.a18c607a.txt";